module.exports = __webpack_public_path__ + "static/team_building-08abd37c6836e65e5f9f88c7c2af589c.jpg";